<template>
    <card-seplag titulo="Visualizar Informações do Ciclo" cor="#00acc1">
        <div class="p-col-12">              
            <Fieldset legend="Ciclo">
                <div class="p-grid p-fluid">      
                    <Rotulo nome="Descrição:" cols='12 4' >
                        <InputText type="text" v-model="cicloRecadastramento.descCiclo" disabled />
                    </Rotulo>              
                    <Rotulo nome="Data Inicio:" cols='12 4'>
                        <InputMask v-model="cicloRecadastramento.dataInicio" mask="99/99/9999" placeholder="99/99/9999" disabled />            
                    </Rotulo>     
                    <Rotulo nome="Data Fim:" cols='12 4'>
                        <InputMask v-model="cicloRecadastramento.dataFinal" mask="99/99/9999" placeholder="99/99/9999" disabled />            
                    </Rotulo>
                </div>
            </Fieldset>
            <Fieldset legend="Exercício">
                <div class="p-grid p-fluid">      
                    <Rotulo nome="Ano selecionado:"  cols='12 4' >
                        <InputText type="text" v-model="cicloRecadastramento.exercicio.ano" disabled  />
                    </Rotulo>
                    <Rotulo nome="Status do Exercício:"  cols='12 4' >
                        <InputText type="text" v-model="cicloRecadastramento.exercicio.statExercicio" disabled  />
                    </Rotulo>
                </div>
            </Fieldset>
            <Fieldset legend="Termo">
                <div class="p-grid p-fluid">      
                    <Rotulo nome="Descrição do Termo:"  cols='12 4' >
                        <InputText type="text" v-model="cicloRecadastramento.termo.descTermo" disabled  />
                    </Rotulo>
                     <Rotulo nome="Obrigatório:"  cols='12 4' >
                        <InputText type="text" v-model="cicloRecadastramento.termo.flagTermoObrigatorio" disabled  />
                    </Rotulo>
                     <Rotulo nome="Status do Termo:"  cols='12 4' >
                        <InputText type="text" v-model="cicloRecadastramento.termo.statTermo" disabled  />
                    </Rotulo>
                     <Rotulo nome="Data de inicio Termo:"  cols='12 4' >
                        <InputText type="text" v-model="cicloRecadastramento.termo.dataInicioTermo" disabled  />
                    </Rotulo>
                     <Rotulo nome="Data Fim Termo:"  cols='12 4' >
                        <InputText type="text" v-model="cicloRecadastramento.termo.dataTerminoTermo" disabled  />
                    </Rotulo>
                     <Rotulo nome="Status do Termo:"  cols='12 4' >
                        <InputText type="text" v-model="cicloRecadastramento.termo.statTermo" disabled  />
                    </Rotulo>
                     <Rotulo nome="Termo de aceite:" cols="12" >
                            <Editor v-model="cicloRecadastramento.termo.infoTermo" editorStyle="height: 250px" disabled />
                    </Rotulo>
                </div>
            </Fieldset>
            <Fieldset legend="Questionário">
                <div class="p-grid p-fluid">      
                    <Rotulo nome="Descrição do Questionário:"  cols='12 4' >
                        <InputText type="text" v-model="cicloRecadastramento.questionario.descQuestionario" disabled  />
                    </Rotulo>
                </div>
                <div class="p-col-12" >
                    <Fieldset legend="Perguntas" >

                        <!-- <table-seplag :dados.sync="cicloRecadastramento.questionario.questionarioPerguntas"  :exibirCabecalho="false"> -->
                        <!-- <Column bodyStyle="text-align: center" header="Perguntas">
                        <template #body="slotProps"> -->
                        <div class="p-col-12">
                            <Questionario  cols="12" :campos.sync="questionarioArray" :isDisabled="true" />
                        </div>
                        <!-- <Accordion>
                        <AccordionTab :header="slotProps.data.pergunta.descPergunta">
                            <h2 v-if="slotProps.data.pergunta.opcoes.length === 0 && slotProps.data.pergunta.siglTipoPergunta === 'OPCAOMULTIPLA' || slotProps.data.pergunta.siglTipoPergunta === 'LISTA'"> Não existem opções cadastradas para essa pergunta </h2>
                        <table-seplag :dados.sync="slotProps.data.pergunta.opcoes"  :exibirCabecalho="false" v-if="slotProps.data.pergunta.opcoes.length > 0">
                        <Rotulo nome="Opções da Pergunta" cols="12" ></Rotulo>
                        <Column bodyStyle="text-align: center" header="Id"  >
                        <template #body="slotProps"> 
                            <span class="customer-badge-pentende">  {{slotProps.data.descOpcaoPegunta}} </span>
                        </template>
                        </Column>
                        </table-seplag>
                        </AccordionTab>             
                        </Accordion> -->
                        <!-- </template> 
                        </Column>  -->
                        <!-- </table-seplag> -->
                    </Fieldset>
                </div>
            </Fieldset>
            <Fieldset legend="Fases">
                <Fieldset legend="Fases selecionadas para esse ciclo">
                    <div class="p-col-12 p-md-8 p-md-offset-2">
                        <table-seplag :dados.sync="cicloRecadastramento.fases" :exibirCabecalho="false" >  
                            <Column header="Descrição">
                                <template #body="slotProps">                                     
                                        <span class="customer-badge-pentende"> {{slotProps.data.descFase}}</span>
                                </template>
                            </Column>  
                        </table-seplag>
                    </div>
                </Fieldset>
            </Fieldset>
            <Fieldset legend="Ciclo Referência">
           </Fieldset>
            <div class="p-col-12">
                <div class="p-grid p-fluid">
                    <div class="p-col-12 p-md-3">
                        <Button label="Voltar" icon="pi pi-arrow-left" class="p-button-rounded" @click="voltarListaCiclo()"/>
                    </div>
                </div>
            </div>
        </div>
    </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from "@/template/RotuloSeplag.vue";
import TableSeplag from '@/template/TableSeplag.vue'
import Questionario from '@/template/QuestionarioSeplag.vue'


export default {
    name: "visualizarCiclo",
    components: {CardSeplag, Rotulo, TableSeplag,Questionario},
    data: function() {
         return {
           cicloRecadastramento : {},
           questionarioArray : []
        }
    },
    methods: {
        carregarDados() {
            this.cicloRecadastramento = JSON.parse(JSON.stringify(this.$store.getters.getCicloSelecionado))
            this.questionarioArray = this.cicloRecadastramento.questionario.questionarioPerguntas.map((pergunta) => {
                return {
                    ...pergunta.pergunta,
                    descQuestionario: " ",
                    ...pergunta,
                    flagObrigatorio: pergunta.flagObrigatorio,
                    options: pergunta.pergunta.opcoes.map((opcao) => {
                        return {
                            code: opcao.idenOpcaoPergunta,
                            name: opcao.descOpcaoPegunta,
                        };
                    }),
                    siglTipoPergunta: pergunta.pergunta.tipoPergunta.siglTipoPergunta,
                    valrRespostaQuesPergunta: "",
                    idenPergunta: pergunta.idenQuestionarioPergunta
                };
            })
            
        },
        voltarListaCiclo() {
            this.$router.push({name:'listaCiclo'})  
        }
    },
    created(){        
        this.carregarDados()
    }
}
</script>

<style scoped>

</style>